/**
 * Formats a date string into an object with separate month and day properties.
 * The function converts any date format with hyphens to use forward slashes
 * before parsing and formatting.
 *
 * @param dateInput - A date string in a format that can be parsed by the Date constructor
 * @param useLongMonth - Optional boolean flag to determine if the month should be displayed
 *                      in its full form (e.g., "January" instead of "Jan"). Default is false.
 * @returns An object containing formatted month and day parts
 * @property {string} month - The formatted month (e.g., "Jan" or "January")
 * @property {string} day - The formatted day (e.g., "1")
 *
 * @example
 * // Returns { month: "Jan", day: "1" }
 * formatStartDate("2023-01-01")
 *
 * @example
 * // Returns { month: "January", day: "1" }
 * formatStartDate("2023-01-01", true)
 */
export const formatStartDate = (dateInput: string, useLongMonth: boolean = false) => {
  // Ensure the date is consistently formatted in a format like "YYYY-MM-DD" to "YYYY/MM/DD"
  const formattedDate = new Date(dateInput.replace(/-/g, '/'))
    .toLocaleString('en-us', {
      month: useLongMonth ? 'long' : 'short',
      day: 'numeric',
    })
    .split(' ');

  return {
    month: formattedDate[0],
    day: formattedDate[1],
  };
};
